/**
 * Created by Administrator on 2018/4/28.
 */



/**
 * 密码强度判断
 * level:强度显示器容器Dom
 * passwordVal:密码框输入的值
 */
export function intensityJudge(level , passwordVal) {
  if (passwordVal.length < 6) {
    level.classList.remove("pw-weak");
    level.classList.remove("pw-medium");
    level.classList.remove("pw-strong");
    level.classList.add("pw-defule");
  }
  if ((/\d/.test(passwordVal) || /[a-z]/.test(passwordVal) )&& passwordVal.length >= 6) {
    level.classList.remove("pw-defule");
    level.classList.remove("pw-medium");
    level.classList.remove("pw-strong");
    level.classList.add("pw-weak");
  }
  if ((/\d/.test(passwordVal) && /[a-z]/.test(passwordVal) ) && passwordVal.length > 8){
    level.classList.remove("pw-weak");
    level.classList.remove("pw-medium");
    level.classList.remove("pw-strong");
    level.classList.add("pw-medium");
  }
  // if((/\d/.test(passwordVal) && /[a-z]/.test(passwordVal) && (/\W/.test(passwordVal)) ) && passwordVal.length > 10){
  if((/\d/.test(passwordVal) && /[a-z]/.test(passwordVal) ) && passwordVal.length > 10){
    level.classList.remove("pw-defule");
    level.classList.remove("pw-weak");
    level.classList.remove("pw-medium");
    level.classList.add("pw-strong");
  }
}


/****************数据存储******************/

/*
*name : 需要存入数据的key
* item:需要存入的数据
* */
export function setLocalStorage(name,item) {
  //数据存储
  sessionStorage.setItem(name , JSON.stringify(item))
}

/*
*name : 需要取数据的key
* callBack:成功取出后的数据的回调
* */
export function getLocalStorage(name,callBack) {
  //数据存储
  var getData = sessionStorage.getItem(name)
  if(getData){
    var res = JSON.parse(getData);
    callBack(res)
  }
}


/*****************判断是否登录*****************/
import { getToken } from '@/utils/auts'
export function ifSignIn(_this,callback) {
  //判断是否登录
  if (!getToken()){
    _this.$router.push({name:'SignIn'});
  }else {
    callback()
  }
}



























// WEBPACK FOOTER //
// ./src/utils/common.js